class ProfetCookieBar {
	constructor() {
		this.cookieIsSet = this.getCookie('cookieBarClosed');
		this.cookiebar = document.querySelector('#cookiebar');
		this.cookiebarClose = document.querySelector('#cookiebar-close');
		this.init();
	}

	init() {
		if (this.cookieIsSet || !this.cookiebar) {
			return;
		}
		this.cookiebar.style.display = 'block';
		this.cookiebar.classList.add('cookie-bar-show');
		this.cookiebarClose.addEventListener('click', (event) => {
			event.preventDefault();
			this.cookiebar.classList.remove('cookie-bar-show');
			this.setCookie('cookieBarClosed', 'true', 3650);
			this.cookiebar.classList.add('slide-down');
		});
	}
	setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		var expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	getCookie(cname) {
		var name = cname + '=';
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
}

window.addEventListener('load', () => {
	window.profetCookieBar = new ProfetCookieBar();
});
